<template>
  <div>
    <h3 class="mb-5">Video Rotate</h3>
    <div class="h4 mb-5">至少三個</div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in csr.video_rotates" :key="i">
      <template v-slot:head>
        <h3>Video {{ i + 1 }}</h3>
      </template>
      <template v-slot:body>
        <!-- UploadType -->
        <div class="form-item d-flex py-5">
          <h4 class="w-100px mr-80px">Upload Type</h4>
          <div class="h4">
            {{
              item.upload_type === 'file'
                ? '自電腦上傳影片'
                : '來自影片連結'
            }}
          </div>
        </div>
        <!-- UploadType: computer -->
        <div v-if="item.upload_type === 'file'">
          <!-- FileLink -->
          <div class="form-item d-flex py-5">
            <h4 class="w-100px mr-80px">檔案連結</h4>
            <div class="h4">
              <a
                :href="item.url"
                class="text-decoration-none"
                style="color: #194cc3"
                >{{ item.url }}</a
              >
            </div>
          </div>
        </div>
        <!-- UploadType: link -->
        <div v-if="item.upload_type === 'link'">
          <!-- Youtube  -->
          <div class="form-item d-flex py-5">
            <h4 class="w-100px mr-80px">影片連結</h4>
            <div class="h4">
              <a
                :href="item.url"
                class="text-decoration-none"
                style="color: #194cc3"
                >{{ item.url }}</a
              >
            </div>
          </div>
          <!-- Youku  -->
          <!--<div class="form-item d-flex py-5">-->
            <!--<h4 class="w-100px mr-80px">Youku</h4>-->
            <!--<div class="h4">-->
              <!--<a-->
                <!--:href="item.youkuUrl"-->
                <!--class="text-decoration-none"-->
                <!--style="color: #194cc3"-->
                <!--&gt;{{ item.youkuUrl }}</a-->
              <!--&gt;-->
            <!--</div>-->
          <!--</div>-->
        </div>
        <!-- Preview Image -->
        <div class="d-flex px-5 py-5">
          <div class="h4">Preview Image</div>
          <div
            class="w-305px h-187px ml-auto bg-cover bg-center"
            :style="{
              'background-image': `url(${item.preview_image})`,
              'border-radius': '6.2px',
              'background-size': 'contain',
            }"
          ></div>
        </div>
      </template>
    </PageCollapse>

    <!-- add item -->
    <!--<div class="mt-5">-->
      <!--<button class="btn btn-outlined w-100 justify-start" @click="addItem()">-->
        <!--<v-icon class="primary&#45;&#45;text mr-2">add_circle</v-icon>-->
        <!--<span>添加 CSR Project</span>-->
      <!--</button>-->
    <!--</div>-->
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    csr: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PageCollapse,
  },
  data: () => ({
    itemList: [
      {
        id: '001',
        uploadType: 'computer',
        fileLink: '/filepath/filename.mp4',
        youtubeUrl: 'youtube.com',
        youkuUrl: 'youku.com',
        imageUrl: '',
      },
      {
        id: '002',
        uploadType: 'link',
        fileLink: '/filepath/filename2.mp4',
        youtubeUrl: 'youtube.com',
        youkuUrl: 'youku.com',
        imageUrl: '',
      },
      {
        id: '003',
        uploadType: 'link',
        fileLink: '/filepath/filename3.mp4',
        youtubeUrl: 'youtube.com',
        youkuUrl: 'youku.com',
        imageUrl: '',
      },
    ],
  }),
  methods: {
    addItem() {
      const template = {
        id: Date.now(),
        uploadType: 'file',
        fileLink: '',
        youtubeUrl: '',
        youkuUrl: '',
        imageUrl: '',
      };
      this.itemList.push(template);
    },
  },
};
</script>

<style></style>
